import gql from "graphql-tag";

export const updateUserProfile = gql`
  mutation UpdateUserProfileRequest($input: UpdateUserProfileRequestInput!) {
    UpdateUserProfileRequest(input: $input) {
      success
    }
  }
`;
